var $10f26aa1cfdb1c9f$exports = {};
$10f26aa1cfdb1c9f$exports = {
    "removeButtonLabel": `Remover`,
    "removeDescription": `Pressione Delete para remover a tag.`
};


export {$10f26aa1cfdb1c9f$exports as default};
//# sourceMappingURL=pt-BR.mjs.map
